import  { channel } from '@/views/im-channel/data.js';
import Bus from '@/utils/bus';
import { deepCopy } from '@/utils/index';

import store from 'store';
export const imChatService = {
	methods: {
		sendMessagetoApi(source){
			let params = {
			    brand: source.brand,
				channel: source.channel,
				msg_id: uuidv4(),
				sender_id: this.$store.state.user.userInfo.userId,//当前坐席id
				sender_type: '2', //1-客户；2-坐席；3 - 系统消息
				sendtime: new Date().getTime(),
				session_id: source.session_id,
				skillGroup: source.skillGroup,
				type: source.type,
				loading:true,
				sendStatus:true,
				sendErrMsg:'',
				msg:source.msg || ''
			}
			switch (source.type){
				case 'image':
				case 'file':
				case 'video':
					params.attachment = {
						fileId:source.attachment.id ? source.attachment.id : source.attachment.uuid,
						filename:source.attachment.filename,
						filetype:source.type,
						url:source.attachment.fileurl ? source.attachment.fileurl : source.attachment.url,
						filesize:source.attachment.filesize,
					}
					break;
				case 'miniprogrampage':
					params.miniProgram = {
						appid:source.miniProgram.appid,
						id:source.miniProgram.id,
						pagepath:source.miniProgram.pagepath,
						thumb_media_id:source.miniProgram.thumbMediaId,
						title:source.miniProgram.title,
					}
					break;
				case 'news':
					params.news = {
						description:source.data.content,
						id:source.attachment.id,
						picurl:source.attachment.fileurl,
						title:source.data.name,
						url:source.attachment.newsurl,
					}
					break;
			}
			this.$store.commit('imChatService/PUSH_DIALOGUE',params);
			let querys = deepCopy(params);
			delete querys.loading;
			delete querys.sendStatus;
			delete querys.sendErrMsg;
			this.$store.commit('imChatService/UPDATE_IM_OPERATE_LOGS',{
				type:`坐席发送消息参数`,
				content:`${JSON.stringify(querys)}`
			})
			this.$store.commit('imChatService/UPDATE_TALK_ITEM', {
			  session_id: params.session_id,
			  draft_text: '',
			})
			this.$nextTick(() => {
				let elChatPanel = document.getElementById('majorelChatPanel');
				  elChatPanel.scrollTop = elChatPanel.scrollHeight;
			})
			return new Promise((resolve, reject) => {
				this.$api.toSendImServiceDialogue(querys).then(response => {
					this.$store.commit('imChatService/UPDATE_IM_OPERATE_LOGS',{
						type:`坐席发送消息响应`,
						content:`响应：${JSON.stringify(response)}`
					})
					if(response.errcode != 0) {
						this.$store.commit('imChatService/UPDATE_DIALOGUE',{
							msg_id:params.msg_id,
							loading:false,
							sendStatus:false,
							sendErrMsg:'网络异常，发送失败'
						})
						// this.$nextTick(() => {
						// 	let elChatPanel = document.getElementById('majorelChatPanel');
						// 	  elChatPanel.scrollTop = elChatPanel.scrollHeight;
						// })
						return;
					}
					this.$store.commit('imChatService/UPDATE_DIALOGUE',{
						msg_id:params.msg_id,
						loading:false
					})
					// this.$nextTick(() => {
					// 	let elChatPanel = document.getElementById('majorelChatPanel');
					// 	  elChatPanel.scrollTop = elChatPanel.scrollHeight;
					// })
					resolve()
				}).catch(err => {
					this.$store.commit('imChatService/UPDATE_DIALOGUE',{
						msg_id:params.msg_id,
						loading:false,
						sendStatus:false,
						sendErrMsg:'网络异常，发送失败'
					})
				})
			})
		},
		
	}
}

// ! 时间日期控件配置
export const pickerOptionsMixin = {
    computed: {
        pickerOptions() {
            return {
                disabledDate: function (date) {
                    let now = new Date();
                    now.setHours(23);
                    now.setMinutes(59);
                    now.setSeconds(59);
                    return date > now;
                },

                onPick: function ({ maxDate }) {
                    this.$nextTick(function () {
                        if (maxDate) {
                            maxDate.setHours(23);
                            maxDate.setMinutes(59);
                            maxDate.setSeconds(59);
                            this.maxDate = maxDate;
                        }
                    });
                },
                // shortcuts: [{
                //     text: '今天',
                //     onClick(picker) {
                //         const end = new Date();
                //         end.setHours(23);
                //         end.setMinutes(59);
                //         end.setSeconds(59);

                //         const start = new Date();
                //         start.setHours(0);
                //         start.setMinutes(0);
                //         start.setSeconds(0);

                //         picker.$emit('pick', [start, end]);
                //     }
                // }, {
                //     text: '昨天',
                //     onClick(picker) {
                //         const end = new Date();
                //         end.setDate(end.getDate() - 1);
                //         end.setHours(23);
                //         end.setMinutes(59);
                //         end.setSeconds(59);

                //         const start = new Date();
                //         start.setDate(start.getDate() - 1);
                //         start.setHours(0);
                //         start.setMinutes(0);
                //         start.setSeconds(0);

                //         picker.$emit('pick', [start, end]);
                //     }
                // }, {
                //     text: '近3天',
                //     onClick(picker) {
                //         const end = new Date();
                //         end.setHours(23);
                //         end.setMinutes(59);
                //         end.setSeconds(59);

                //         const start = new Date();
                //         start.setDate(start.getDate() - 2);
                //         start.setHours(0);
                //         start.setMinutes(0);
                //         start.setSeconds(0);

                //         picker.$emit('pick', [start, end]);
                //     }
                // }, {
                //     text: '近7天',
                //     onClick(picker) {
                //         const end = new Date();
                //         end.setHours(23);
                //         end.setMinutes(59);
                //         end.setSeconds(59);

                //         const start = new Date();
                //         start.setDate(start.getDate() - 6);
                //         start.setHours(0);
                //         start.setMinutes(0);
                //         start.setSeconds(0);

                //         picker.$emit('pick', [start, end]);
                //     }
                // }]
            };
        },
        monthPickerOptions() {
            return {
                disabledDate: function (date) {
                    let now = new Date();
                    now.setHours(23);
                    now.setMinutes(59);
                    now.setSeconds(59);
                    return date > now;
                },

                onPick: function ({ maxDate }) {
                    this.$nextTick(function () {
                        if (maxDate) {
                            maxDate.setHours(23);
                            maxDate.setMinutes(59);
                            maxDate.setSeconds(59);
                            this.maxDate = maxDate;
                        }
                    });
                },
                shortcuts: [{
                    text: '本月',
                    onClick(picker) {
                        picker.$emit('pick', [new Date(), new Date()]);
                    }
                }, {
                    text: '今年至今',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date(new Date().getFullYear(), 0);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近六个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setMonth(start.getMonth() - 5);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            };
        }
    }
};

export const tableMixin = {
    methods: {
        tableHeaderClassName(row, column, rowIndex, columnIndex) {
            return 'table-header-bg';
        },
        tableRowClassStyle(row, column, rowIndex, columnIndex) {
            return {
                'height': '50px !important',
                'min-height': '50x !important',
            };
		},
		//分页记忆选择
		changePageCoreRecordData(){
			// 标识当前行的唯一键的名称
			let idKey = this.idKey;
			let that = this;
			// 如果总记忆中还没有选择的数据，那么就直接取当前页选中的数据，不需要后面一系列计算
			if (this.multipleSelectionAll.length <= 0) {
				this.multipleSelectionAll = this.multipleSelection;
				return;
			}
			// 总选择里面的key集合
			let selectAllIds = [];
			this.multipleSelectionAll.forEach(row => {
				selectAllIds.push(row[idKey]);
			});
			let selectIds = [];
			// 获取当前页选中的id
			this.multipleSelection.forEach(row => {
				selectIds.push(row[idKey]);
				// 如果总选择里面不包含当前页选中的数据，那么就加入到总选择集合里
				if (selectAllIds.indexOf(row[idKey]) < 0) {
					that.multipleSelectionAll.push(row);
				}
			});
			let noSelectIds = [];
			// 得到当前页没有选中的id
			this.list.forEach(row => {
				if (selectIds.indexOf(row[idKey]) < 0) {
					noSelectIds.push(row[idKey]);
				}
			});
			noSelectIds.forEach(id => {
				if (selectAllIds.indexOf(id) >= 0) {
					for (let i = 0; i < that.multipleSelectionAll.length; i++) {
						if (that.multipleSelectionAll[i][idKey] == id) {
							// 如果总选择中有未被选中的，那么就删除这条
							that.multipleSelectionAll.splice(i, 1);
							i --
							break;
						}
					}
				}
			});
		},
		// 设置选中的方法
		setSelectRow(refTable) {
			if (!this.multipleSelectionAll || this.multipleSelectionAll.length <= 0) {
				return;
			}
			// 标识当前行的唯一键的名称
			let idKey = this.idKey;
			let selectAllIds = [];
		
			this.multipleSelectionAll.forEach(row => {
				selectAllIds.push(row[idKey]);
			});
			this.$refs[refTable].$refs.elTable.clearSelection();
			for (var i = 0; i < this.list.length; i++) {
				if (selectAllIds.indexOf(this.list[i][idKey]) >= 0) {
					// 设置选中，记住table组件需要使用ref="table"
					this.$refs[refTable].$refs.elTable.toggleRowSelection(this.list[i], true);
				}
			}
		}
    }
};



export const EnumMixin = {
    methods: {
        getChannelStatus(value) {
			return store.getters.channelList.filter((item) => item.id == value).length > 0 ? store.getters.channelList.filter((item) => item.id == value)[0]['name'] : value;
        },
		formatChannel(row){
			let result  = channel.filter(el => el.key == row.channel)
			if(result.length > 0) return result[0].name
			return '--'
		}
    }
};

export const tagviewsMixins = {
	methods: {
		closeTab(path) {
			let routeData = this.visitedViews.find(view => view.path == path);
			this.closeSelectedTag(routeData);
		},
		isActive(route) {
			return route.path === this.$route.path
		},
		toLastView(visitedViews, view) {
			const latestView = visitedViews.slice(-1)[0]
			if (latestView) {
				this.$router.push(latestView.fullPath)
			} else {
				// now the default is to redirect to the home page if there is no tags-view,
				// you can adjust it according to your needs.
				if (view.name === 'Dashboard') {
					// to reload home page
					this.$router.replace({
						path: '/redirect' + view.fullPath
					})
				} else {
					this.$router.push('/')
				}
			}
		},
		closeSelectedTag(view) {
			if (view.path == "/welcome") {
				return
			}
			this.$store.dispatch('tagsView/delView', view).then(({
				visitedViews
			}) => {
				if (this.isActive(view)) {
					this.toLastView(visitedViews, view)
					const latestView = visitedViews.slice(-1)[0];
					if (latestView) {
						this.$router.push(latestView);
					} else {
						this.$router.push("/");
					}
				}
				//关闭单个
				Bus.$emit("removeCache", "closeSelectedTag", view);
			})
		},
		refreshSelectedTag() {
			let view = this.$route;
			this.$store.dispatch('tagsView/delCachedView', view).then(() => {
				const {
					fullPath
				} = view
				this.$nextTick(() => {
					this.$router.replace({
						path: '/redirect' + fullPath
					})
				})
			})
			Bus.$emit("removeCache", "closeSelectedTag", this.$route);
		},
	}
}

export const filterHeaderSearch = {
	methods:{
		filterSelectRemote(params){
			this.filterHeader[params.index]['loading'] = true;
			switch(params.row.model){
				case 'campaignId': //外呼活动
					this.getCampaignIdForHeader(params);
					break;
				case 'subjectId': //外呼主题
					this.getSubjectIdForHeader(params);
					break;
				case 'originalBatchNum': //数据文件
				case 'batchNum': //数据文件
					this.getBatchNumForHeader(params);
					break;
				case 'paperId': //外呼问卷
					this.getPaperIdForHeader(params);
					break;
				case 'userId': //所有人员
					this.geUserIdForHeader(params);
					break;
				case 'taskStatus': //任务状态
					this.getTaskStatusForHeader(params);
					break;
					
			}
		},
		getSubjectIdForHeader(data){
			this.$api.getBreathThemeList({
				brandIdentify:this.$store.getters.userInfo.brandIdentify,
				childBrandIdentify:this.listQuery.childBrandIdentify,
				campaignId:this.listQuery.campaignId || '',
				pageSize:50,
				pageNumber:1,
				subjectName: data.query || ''
			}).then(res => {
				this.filterHeader[data.index]['loading'] = false;
				if(res.errcode != 0) return;
				this.filterHeader[data.index]['list'] = res.data;
			})
		},
		geUserIdForHeader(data){
			let params = {
				data: {
					brandIdentify:this.$store.getters.userInfo.brandIdentify,
				    account:  data.query || '',
				    userType: '',
				},
				orderBy: null,
				pageNum: 1,
				pageSize: 50
			}
			if(this.listQuery.childBrandIdentify){
				params.data.brandList = [this.listQuery.childBrandIdentify];
			}
			this.$api.getAllPlatformUserList(params).then(res => {
				this.filterHeader[data.index]['loading'] = false;
				if(res.errcode != 0) return;
				this.filterHeader[data.index]['list'] = res.list;
				
			})
		},
		getBatchNumForHeader(data){
			this.$api.getBreathdataBaseFileList({
				brandIdentify:this.$store.getters.userInfo.brandIdentify,
				pageNumber:1,
				pageSize:50,
				childBrandIdentify:this.listQuery.childBrandIdentify,
				name: data.query || '',
				subjectId:this.listQuery.subjectId
			}).then(res => {
				this.filterHeader[data.index]['loading'] = false;
				if(res.errcode != 0) return;
				this.filterHeader[data.index]['list'] = res.data;
				if(data.row.p_model && data.p_lists){
					let index = data.p_lists.findIndex(el => el.subjectId == this.listQuery.subjectId);
					if(index != -1){
						this.listQuery[data.row.model] =data.p_lists[index]['originalBatchNum'];
					}else {
						this.listQuery[data.row.model] = ''
					}
				}
			})
		},
		getCampaignIdForHeader(data){
			this.$api.getBreathThemeTypesList({
				brandIdentify:this.$store.getters.userInfo.brandIdentify,
				childBrandIdentify:this.listQuery.childBrandIdentify,
				campaignName: data.query || '',
				pageSize:50,
				pageNumber:1,
			}).then(res => {
				this.filterHeader[data.index]['loading'] = false;
				if(res.errcode != 0) return;
				this.filterHeader[data.index]['list'] = res.data;
			})
		},
		getPaperIdForHeader(data){
			this.$api.apiGetSurveyPaperList({
				pageSize: 50,
				pageNumber: 1,
				brandIdentify:this.$store.getters.userInfo.brandIdentify,
				subBrandIdentify: this.listQuery.childBrandIdentify,
				paperName: data.query || '',
				paperStatus: '0',
				channelIdentify: '',
				paperId: '',
			}).then(res => {
				this.filterHeader[data.index]['loading'] = false;
				if(res.errcode != 0) return;
				this.filterHeader[data.index]['list'] = res.data;
				
			})
		},
		getTaskStatusForHeader(data){
			this.$api.getBreathTaskStatus({
				brandIdentify:this.$store.getters.userInfo.brandIdentify,
			}).then(res => {
				this.filterHeader[data.index]['loading'] = false;
				if(res.errcode != 0) return;
				this.filterHeader[data.index]['list'] = res.data;
			})
		},
	}
}